// components/MonthFilterPanel.js
import React from "react";

const MonthFilter = ({
  months,
  selectedMonth,
  handleMonthSelect,
  selectedYear,
  handleYearChange,
  filterDay,
  setFilterDay,
  filterStatusP,
  setFilterStatusP,
  filterModel,
  setFilterModel,
  handleClear,
  getDaysInMonth,
  isMobile,
}) => {
  return isMobile ? (
    <div className="flex flex-col my-2">
      <select
        className="border p-2 mr-2"
        value={selectedMonth}
        onChange={(e) => handleMonthSelect(e.target.value)}
      >
        <option value="" disabled>Select Month</option>
        {months.map((month) => (
          <option key={month} value={month}>{month}</option>
        ))}
      </select>

      <select
        name="filterDay"
        className="border p-2 mr-2 my-2"
        value={filterDay}
        onChange={(e) => setFilterDay(e.target.value)}
        disabled={!selectedMonth}
      >
        <option value="" disabled>Filter by Day</option>
        {selectedMonth &&
          Array.from({ length: getDaysInMonth(selectedMonth) }, (_, i) => i + 1)
            .map((day) => (
              <option key={day} value={day}>{day}</option>
            ))}
      </select>

      <select
        name="filterStatusP"
        className="border p-2 mr-2 mb-2"
        value={filterStatusP}
        onChange={(e) => setFilterStatusP(e.target.value)}
      >
        <option value="" disabled>Filter by Status</option>
        <option value="Ordered">Ordered</option>
        <option value="Received">Received</option>
        <option value="Sent">Sent</option>
        <option value="Sold">Sold</option>
        <option value="Custom">Custom</option>
        <option value="Returned">Returned</option>
        <option value="Unpaid">Unpaid</option>
      </select>

      <input
        type="text"
        name="model"
        className="border p-2 mr-2 mb-2"
        placeholder="Filter by Model"
        value={filterModel}
        onChange={(e) => setFilterModel(e.target.value)}
      />

      <button
        onClick={handleClear}
        className="bg-slate-600 hover:bg-slate-500 text-white font-bold px-4 mb-2 rounded"
      >
        Clear
      </button>
    </div>
  ) : (
    <div className="flex flex-row my-2 items-center flex-wrap gap-2">
      <select
        className="border p-2"
        value={selectedMonth}
        onChange={(e) => handleMonthSelect(e.target.value)}
      >
        <option value="" disabled>Select Month</option>
        {months.map((month) => (
          <option key={month} value={month}>{month}</option>
        ))}
      </select>

      <input
        type="number"
        value={selectedYear}
        onChange={handleYearChange}
        min="2000"
        max={new Date().getFullYear()}
        className="border p-2 w-24"
      />

      <select
        name="filterDay"
        className="border p-2"
        value={filterDay}
        onChange={(e) => setFilterDay(e.target.value)}
        disabled={!selectedMonth}
      >
        <option value="" disabled>Filter by Day</option>
        {selectedMonth &&
          Array.from({ length: getDaysInMonth(selectedMonth) }, (_, i) => i + 1)
            .map((day) => (
              <option key={day} value={day}>{day}</option>
            ))}
      </select>

      <select
        name="filterStatusP"
        className="border p-2"
        value={filterStatusP}
        onChange={(e) => setFilterStatusP(e.target.value)}
      >
        <option value="" disabled>Filter by Status</option>
        <option value="Ordered">Ordered</option>
        <option value="Received">Received</option>
        <option value="Sent">Sent</option>
        <option value="Sold">Sold</option>
        <option value="Custom">Custom</option>
        <option value="Returned">Returned</option>
        <option value="Unpaid">Unpaid</option>
      </select>

      <input
        type="text"
        name="model"
        className="border p-2"
        placeholder="Filter by Model"
        value={filterModel}
        onChange={(e) => setFilterModel(e.target.value)}
      />

      <button
        onClick={handleClear}
        className="bg-slate-600 hover:bg-slate-500 text-white font-bold px-4 rounded"
      >
        Clear
      </button>
    </div>
  );
};

export default MonthFilter;
